// src/pages/admin/SponsoredShelves.jsx
import { useEffect, useState } from 'react'
import {
  addSponsoredShelf,
  updateSponsoredShelf,
  deleteSponsoredShelf,
  addShelfProduct,
  listShelfProducts,
  removeShelfProduct,
  fetchActiveShelves,
} from '../../lib/sponsored'

import {
  collection,
  getDocs,
  query as fsQuery,
  where,
  limit,
} from 'firebase/firestore'
import { db } from '../../firebase'

export default function SponsoredShelves() {
  const [shelves, setShelves] = useState([])
  const [loading, setLoading] = useState(true)
  const [editing, setEditing] = useState(null)
  const [form, setForm] = useState({})
  const [productsLinks, setProductsLinks] = useState([])
  const [newProductId, setNewProductId] = useState('')

  // 🔎 recherche produit par Name
  const [searchTerm, setSearchTerm] = useState('')
  const [searchResults, setSearchResults] = useState([])
  const [searchLoading, setSearchLoading] = useState(false)
  const [searchError, setSearchError] = useState('')

  async function load() {
    setLoading(true)
    const data = await fetchActiveShelves(20)
    setShelves(data)
    setLoading(false)
  }

  useEffect(() => {
    load()
  }, [])

  function startEdit(shelf) {
    setEditing(shelf)
    setForm({
      title: shelf.title || '',
      subtitle: shelf.subtitle || '',
      ctaLabel: shelf.ctaLabel || 'Shop now',
      ctaHref: shelf.ctaHref || '/catalog',
      bannerImageUrl: shelf.bannerImageUrl || '',
      rightTitle: shelf.rightTitle || '',
      rightSubtitle: shelf.rightSubtitle || '',
      badgeLabel: shelf.badgeLabel || '',
      position: shelf.position || 1,
      isActive: shelf.isActive ?? true,
    })
    loadShelfProducts(shelf.id)
    // reset search zone
    setSearchTerm('')
    setSearchResults([])
    setSearchError('')
  }

  async function loadShelfProducts(id) {
    const links = await listShelfProducts(id)
    setProductsLinks(links)
  }

  function handleChange(e) {
    const { name, value, type, checked } = e.target
    setForm(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value,
    }))
  }

  async function handleSave(e) {
    e.preventDefault()
    if (editing) {
      await updateSponsoredShelf(editing.id, {
        ...form,
        position: Number(form.position) || 1,
      })
    } else {
      await addSponsoredShelf({
        ...form,
        position: Number(form.position) || 1,
      })
    }
    setEditing(null)
    setForm({})
    setProductsLinks([])
    setSearchResults([])
    await load()
  }

  async function handleDelete(id) {
    if (!window.confirm('Supprimer ce bloc sponsorisé ?')) return
    await deleteSponsoredShelf(id)
    if (editing && editing.id === id) {
      setEditing(null)
      setProductsLinks([])
      setSearchResults([])
    }
    await load()
  }

  async function handleAddProduct(e) {
    e.preventDefault()
    if (!editing || !newProductId.trim()) return
    await addShelfProduct(
      editing.id,
      newProductId.trim(),
      productsLinks.length + 1
    )
    setNewProductId('')
    await loadShelfProducts(editing.id)
  }

  async function handleRemoveProduct(linkId) {
    if (!editing) return
    await removeShelfProduct(editing.id, linkId)
    await loadShelfProducts(editing.id)
  }

  // 🔍 Recherche produits par Name (ou searchKeywords)
  // async function handleSearchProducts(e) {
  //   e.preventDefault()
  //   setSearchError('')
  //   setSearchResults([])

  //   if (!editing) {
  //     setSearchError("Sélectionnez d'abord un bloc à éditer.")
  //     return
  //   }
  //   if (!searchTerm.trim()) return

  //   const term = searchTerm.trim().toLowerCase()
  //   setSearchLoading(true)

  //   try {
  //     // 1️⃣ essai via searchKeywords (rempli par VendorProducts)
  //     let results = []
  //     try {
  //       const q1 = fsQuery(
  //         collection(db, 'productsShop'),
  //         where('searchKeywords', 'array-contains', term),
  //         limit(20)
  //       )
  //       const snap1 = await getDocs(q1)
  //       results = snap1.docs.map(d => ({ id: d.id, ...d.data() }))
  //     } catch {
  //       // ignore index errors, on fera un fallback
  //     }

  //     // 2️⃣ fallback si rien trouvé ou pas d’index :
  //     if (!results.length) {
  //       const snap2 = await getDocs(
  //         fsQuery(collection(db, 'productsShop'), limit(60))
  //       )
  //       const all = snap2.docs.map(d => ({ id: d.id, ...d.data() }))
  //       results = all.filter(p => {
  //         const name =
  //           p.Name ||
  //           p.name ||
  //           p.title ||
  //           p.Title ||
  //           ''
  //         return name.toLowerCase().includes(term)
  //       })
  //     }

  //     setSearchResults(results)
  //     if (!results.length) {
  //       setSearchError('Aucun produit trouvé pour ce nom.')
  //     }
  //   } catch (err) {
  //     console.error('Erreur recherche produits :', err)
  //     setSearchError(
  //       "Erreur lors de la recherche de produits. Vérifiez éventuellement l'index Firestore."
  //     )
  //   } finally {
  //     setSearchLoading(false)
  //   }
  // }
async function handleSearchProducts(e) {
  e.preventDefault();
  setSearchError("");
  setSearchResults([]);

  if (!editing) {
    setSearchError("Sélectionnez d'abord un bloc à éditer.");
    return;
  }
  if (!searchTerm.trim()) return;

  const term = searchTerm.trim().toLowerCase();
  setSearchLoading(true);

  try {
    let results = [];

    // 1️⃣ essai via searchKeywords (rempli par VendorProducts)
    try {
      const q1 = fsQuery(
        collection(db, "productsShop"),
        where("validationStatus", "==", "validated"), // ✅ ajouté
        where("searchKeywords", "array-contains", term),
        limit(20)
      );
      const snap1 = await getDocs(q1);
      results = snap1.docs.map((d) => ({ id: d.id, ...d.data() }));
    } catch {
      // ignore index errors, on fera un fallback
    }

    // 2️⃣ fallback si rien trouvé ou pas d’index :
    if (!results.length) {
      const snap2 = await getDocs(
        fsQuery(
          collection(db, "productsShop"),
          where("validationStatus", "==", "validated"), // ✅ ajouté
          limit(60)
        )
      );

      const all = snap2.docs.map((d) => ({ id: d.id, ...d.data() }));

      results = all.filter((p) => {
        const name = p.Name || p.name || p.title || p.Title || "";
        return name.toLowerCase().includes(term);
      });
    }

    setSearchResults(results);

    if (!results.length) {
      setSearchError("Aucun produit trouvé pour ce nom.");
    }
  } catch (err) {
    console.error("Erreur recherche produits :", err);
    setSearchError(
      "Erreur lors de la recherche de produits. Vérifiez éventuellement l'index Firestore."
    );
  } finally {
    setSearchLoading(false);
  }
}
  // ➕ Ajout direct d’un produit trouvé par recherche
  async function handleAddProductFromSearch(prod) {
    if (!editing) return
    await addShelfProduct(
      editing.id,
      prod.id,
      productsLinks.length + 1
    )
    await loadShelfProducts(editing.id)
  }

  // helper affichage nom produit
  const formatProductName = p =>
    p.shortName || p.Name || p.name || p.title || p.Title || p.id

  return (
    <div className="container py-4">
      <h2 className="mb-3">Blocs sponsorisés</h2>

      {/* Liste des blocs */}
      {loading ? (
        <div>Chargement…</div>
      ) : (
        <div className="mb-4">
          <button
            className="btn btn-primary btn-sm mb-3"
            onClick={() => {
              setEditing(null)
              setForm({
                title: '',
                subtitle: '',
                ctaLabel: 'Shop now',
                ctaHref: '/catalog',
                bannerImageUrl: '',
                rightTitle: '',
                rightSubtitle: '',
                badgeLabel: '',
                position: shelves.length + 1,
                isActive: true,
              })
              setProductsLinks([])
              setSearchResults([])
              setSearchTerm('')
            }}
          >
            + Nouveau bloc sponsorisé
          </button>

          <table className="table table-sm align-middle">
            <thead>
              <tr>
                <th>#</th>
                <th>Titre</th>
                <th>Sous-titre</th>
                <th>Position</th>
                <th>Actif</th>
                <th />
              </tr>
            </thead>
            <tbody>
              {shelves.map((s, idx) => (
                <tr key={s.id}>
                  <td>{idx + 1}</td>
                  <td>
                    {s.title || (
                      <span className="text-muted">Sans titre</span>
                    )}
                  </td>
                  <td className="text-truncate" style={{ maxWidth: 260 }}>
                    {s.subtitle}
                  </td>
                  <td>{s.position}</td>
                  <td>{s.isActive ? '✅' : '⛔'}</td>
                  <td className="text-end">
                    <button
                      className="btn btn-link btn-sm"
                      onClick={() => startEdit(s)}
                    >
                      Modifier
                    </button>
                    <button
                      className="btn btn-link btn-sm text-danger"
                      onClick={() => handleDelete(s.id)}
                    >
                      Supprimer
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {/* Formulaire d’édition / création */}
      {Object.keys(form).length > 0 && (
        <div className="row g-4">
          <div className="col-lg-7">
            <form onSubmit={handleSave} className="card-modern p-3">
              <h5 className="mb-3">
                {editing
                  ? 'Modifier le bloc'
                  : 'Nouveau bloc sponsorisé'}
              </h5>

              <div className="mb-2">
                <label className="form-label">
                  Titre (zone texte au-dessus de l’image)
                </label>
                <input
                  className="form-control"
                  name="title"
                  value={form.title}
                  onChange={handleChange}
                />
              </div>

              <div className="mb-2">
                <label className="form-label">
                  Sous-titre (gros texte sur l’image)
                </label>
                <input
                  className="form-control"
                  name="subtitle"
                  value={form.subtitle}
                  onChange={handleChange}
                />
              </div>

              <div className="mb-2">
                <label className="form-label">
                  Image bannière (URL)
                </label>
                <input
                  className="form-control"
                  name="bannerImageUrl"
                  value={form.bannerImageUrl}
                  onChange={handleChange}
                />
              </div>

              <div className="row">
                <div className="col-md-6 mb-2">
                  <label className="form-label">Texte bouton (CTA)</label>
                  <input
                    className="form-control"
                    name="ctaLabel"
                    value={form.ctaLabel}
                    onChange={handleChange}
                  />
                </div>
                <div className="col-md-6 mb-2">
                  <label className="form-label">
                    Lien bouton (CTA href)
                  </label>
                  <input
                    className="form-control"
                    name="ctaHref"
                    value={form.ctaHref}
                    onChange={handleChange}
                  />
                </div>
              </div>

              <hr />

              <div className="mb-2">
                <label className="form-label">
                  Titre colonne produits (ex: Tastes like fall)
                </label>
                <input
                  className="form-control"
                  name="rightTitle"
                  value={form.rightTitle}
                  onChange={handleChange}
                />
              </div>

              <div className="mb-2">
                <label className="form-label">
                  Sous-titre colonne produits
                </label>
                <input
                  className="form-control"
                  name="rightSubtitle"
                  value={form.rightSubtitle}
                  onChange={handleChange}
                />
              </div>

              <div className="row">
                <div className="col-md-4 mb-2">
                  <label className="form-label">
                    Badge (Rollback, Promo...)
                  </label>
                  <input
                    className="form-control"
                    name="badgeLabel"
                    value={form.badgeLabel}
                    onChange={handleChange}
                  />
                </div>
                <div className="col-md-4 mb-2">
                  <label className="form-label">Position</label>
                  <input
                    type="number"
                    className="form-control"
                    name="position"
                    value={form.position}
                    onChange={handleChange}
                  />
                </div>
                <div className="col-md-4 mb-2 d-flex align-items-end">
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id="isActive"
                      name="isActive"
                      checked={!!form.isActive}
                      onChange={handleChange}
                    />
                    <label
                      className="form-check-label"
                      htmlFor="isActive"
                    >
                      Actif
                    </label>
                  </div>
                </div>
              </div>

              <div className="mt-3 d-flex justify-content-end gap-2">
                <button
                  type="button"
                  className="btn btn-light btn-sm"
                  onClick={() => {
                    setEditing(null)
                    setForm({})
                    setProductsLinks([])
                    setSearchResults([])
                  }}
                >
                  Annuler
                </button>
                <button
                  type="submit"
                  className="btn btn-primary btn-sm"
                >
                  Enregistrer
                </button>
              </div>
            </form>
          </div>

          {/* Gestion des produits de ce bloc */}
          {editing && (
            <div className="col-lg-5">
              <div className="card-modern p-3 h-100">
                <h6 className="mb-2">Produits du bloc</h6>
                <p className="small text-muted mb-2">
                  Tu peux ajouter un produit soit par son ID Firestore,
                  soit en le recherchant par son nom.
                </p>

                {/* Ajout direct par ID */}
                <form
                  className="d-flex gap-2 mb-3"
                  onSubmit={handleAddProduct}
                >
                  <input
                    className="form-control form-control-sm"
                    placeholder="ID produit Firestore"
                    value={newProductId}
                    onChange={e => setNewProductId(e.target.value)}
                  />
                  <button
                    className="btn btn-outline-secondary btn-sm"
                    type="submit"
                  >
                    Ajouter ID
                  </button>
                </form>

                {/* 🔎 Recherche par nom */}
                <form
                  className="mb-2"
                  onSubmit={handleSearchProducts}
                >
                  <div className="input-group input-group-sm">
                    <input
                      className="form-control"
                      placeholder="Rechercher par nom (Name)…"
                      value={searchTerm}
                      onChange={e => setSearchTerm(e.target.value)}
                    />
                    <button
                      className="btn btn-primary"
                      type="submit"
                      disabled={searchLoading}
                    >
                      {searchLoading ? 'Recherche…' : 'Chercher'}
                    </button>
                  </div>
                </form>
                {searchError && (
                  <div className="small text-danger mb-2">
                    {searchError}
                  </div>
                )}

                {/* Résultats de recherche */}
                {searchResults.length > 0 && (
                  <div className="mb-3 small">
                    <div className="fw-semibold mb-1">
                      Résultats de recherche
                    </div>
                    <ul className="list-group list-group-flush">
                      {searchResults.map(p => (
                        <li
                          key={p.id}
                          className="list-group-item d-flex justify-content-between align-items-center"
                        >
                          <div>
                            <div className="fw-semibold">
                              {formatProductName(p)}
                            </div>
                            <div className="text-muted">
                              <code>{p.id}</code>{' '}
                              {p.SalePrice && (
                                <span>
                                  –{' '}
                                  {p.SalePrice.toLocaleString()} FCFA
                                </span>
                              )}
                            </div>
                          </div>
                          <button
                            type="button"
                            className="btn btn-success btn-sm"
                            onClick={() =>
                              handleAddProductFromSearch(p)
                            }
                          >
                            Ajouter
                          </button>
                        </li>
                      ))}
                    </ul>
                  </div>
                )}

                {/* Produits déjà liés au bloc */}
                <div className="small">
                  <div className="fw-semibold mb-1">
                    Produits déjà dans ce bloc
                  </div>
                  <ul className="list-group list-group-flush">
                    {productsLinks.map(l => (
                      <li
                        key={l.id}
                        className="list-group-item d-flex justify-content-between align-items-center"
                      >
                        <span>
                          <code>{l.productId}</code>
                          {typeof l.sortOrder === 'number' && (
                            <span className="text-muted">
                              {' '}
                              (#{l.sortOrder})
                            </span>
                          )}
                        </span>
                        <button
                          type="button"
                          className="btn btn-link btn-sm text-danger"
                          onClick={() => handleRemoveProduct(l.id)}
                        >
                          Supprimer
                        </button>
                      </li>
                    ))}
                    {!productsLinks.length && (
                      <li className="list-group-item text-muted">
                        Aucun produit pour le moment.
                      </li>
                    )}
                  </ul>
                </div>
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  )
}
